<template>
    <div class="bottom-menu-bar detail-bottom-menu-bar dsp-flex">
        <!-- <div class="bottom-menu-item" @click="clickStartDiscuss">
            <p><i class="iconbg icon-dt-lunpan-add"></i></p>
            <p class="bm-text">发起论盘</p>
        </div> -->
        <div class="bottom-menu-item" @click="clickPiPan">
            <p class="bm-icon-p"><i class="iconbg icon-dt-pipan" v-bind:class="{'icon-dt-pipan-org': baziNumData.pipan != 0 || baziNumData.otherpipan != 0}"></i></p>
            <p class="bm-text" v-bind:class="{'text-green': baziNumData.pipan != 0 || baziNumData.otherpipan != 0}">批盘</p>
        </div>
        <div class="bottom-menu-item" @click="clickLunPan">
            <p class="bm-icon-p"><i class="iconbg icon-dt-lunpan" v-bind:class="{'icon-dt-lunpan-org': baziNumData.nunpan != 0}"></i></p>
            <p class="bm-text" v-bind:class="{'text-green': baziNumData.nunpan != 0}">论盘</p>
        </div>
        <div class="bottom-menu-item" @click="clickContrast">
            <p class="bm-icon-p"><i class="iconfont icon-comp"></i></p>
            <p class="bm-text">对比合盘</p>
        </div>
        <div class="bottom-menu-item bottom-menu-mid" @click="clickQrCode">
            <div class="bottom-menu-qrcode-box">
                <div class="bottom-menu-qrcode">
                    <qrcode id='qrImg' tag="img" :options="{size: 150, padding: 0}" :value="qrCodeValue" :quality="1" ></qrcode>
                    <i class="iconbg icon-qr-logo"></i>
                </div>
                <div class="bottom-menu-qrcode-note"></div>
            </div>
        </div>
        <div class="bottom-menu-item bottom-menu-right" @click="clickDS">
            <div class="bottom-menu-ds"></div>
        </div>
        <div class="bottom-menu-item bottom-menu-right" @click="clickYearReport">
            <div class="bottom-menu-year" :style="settingConfigData.year_bz ? 'background-image: url('+settingConfigData.year_bz+')' : ''"></div>
        </div>
        <div class="bottom-menu-item bottom-menu-right" @click="clickReport">
            <div class="bottom-menu-report " v-bind:class="{'report-on': personInfo.ai != 0}"></div>
        </div>
        <div v-if="showTips" class="deep-seek-tips tips-1"></div>
        <div v-if="!aitips" class="report-tips report-tips-2"></div>
    </div>
</template>

<script>
import { SHARE } from '../../modules/share';
import { MIX } from '../../modules/utils';
export default {
    name: 'DetailBottomBar',
    computed: {
        aiButtonClickedStatus() {
            return this.$store.state.reminder.aiButtonClickedStatus;
        },
        personInfo() {
            return this.$store.state.detail.personInfo;
        },
        baziNumData() {
            return this.$store.state.detail.baziNumData;
        },
        qrCodeValue() {
            return this.$store.state.detail.qrCodeValue;
        },
        aitips() {
            return this.$store.state.reminder.aitips;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        shareData() {
            return this.$store.state.share.shareData;
        }
    },
    data() {
        return {
            showTips: window.localStorage.getItem('h5_fate_ds_detail_tips') ? false : true,
        }
    },
    mounted: function() {
        var me = this;
        // 手动设置二维码的样式大小
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods:{
        initDom() {
            function setDom() {
                // var qrImg = document.getElementById('qrImg');
                // if(qrImg) {
                //     qrImg.style.width = '60px'; qrImg.style.height = '60px';
                // }
                var pilunDiv = document.getElementsByClassName('bottom-menu-pilun')[0];
                if(pilunDiv) {
                    pilunDiv.style.width = pilunDiv.clientHeight + 'px';
                    pilunDiv.style.lineHeight = (pilunDiv.clientHeight - 2) + 'px';
                }
                var redCircleNode = document.getElementById('pilunRed');
                if(redCircleNode) {
                    redCircleNode.style.left = (pilunDiv.clientHeight - redCircleNode.clientHeight - 5) + 'px';
                }
            }
            setDom();
            
            // 添加改变屏幕大小后的适配,for Wechat PC
            window.onresize = function(){
                setTimeout(() => {
                    setDom();
                }, 20);
            }
            // window.onorientationchange = function() {
            //     setTimeout(() => {
            //         setDom();
            //     }, 20);
            // }
            window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function(){
                setTimeout(() => {
                    setDom();
                }, 20);
            }, false);
        },
        clickQrCode(){
            MIX.trackButtonClicked('mingpan_bottom_qrcode');
            this.$store.state.detail.showQrCodePop = true;
        },
        clickContrast() {
            MIX.trackButtonClicked('mingpan_bottom_compare');
            this.$store.state.contrast.showContrastCreatePanel = true;
        },
        clickPiLun() {
            if(this.shareData.type == 4) {
                this.$store.state.detail.showDetailSharePop = true;
            }else {
                this.$store.dispatch('detail/getBaziNum');
            }
        },
        clickPiPan() {
            MIX.trackButtonClicked('mingpan_bottom_pipan');
            this.$bus.emit('clearDetailNatureTime');
            // 初始化数据:批盘数据和他人批盘的列表数据一起拉下来
            var me = this;
            var personInfo = this.$store.state.detail.personInfo;
            if(personInfo.pipan != 0) {
                // 先重置，再初始化mini命盘的数据
                this.goToMyComment();
            }else {
                if(personInfo.otherpipan != 0) {
                    this.$store.dispatch('othercomment/getOtherPiPanList', {
                        detailId: personInfo.id,
                        cb: function() {
                            me.goToOtherComment();
                        }
                    });
                }else {
                    this.goToMyComment();
                }
            }
        },
        goToMyComment() {
            var me = this,
                personInfo = this.$store.state.detail.personInfo;
            this.$store.dispatch('othercomment/getOtherPiPanList', {
                detailId: personInfo.id
            });
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch('minifatefortune/initCommentMiniFateFortune', personInfo);
            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('comment/initPiPan', {
                detailData: personInfo,
                cb: function() {
                    // 页面跳转
                    me.$router.replace('/comment/detail/' + personInfo.id);
                    SHARE.initConfigShare();
                }
            });
        },
        goToOtherComment() {
            var me = this,
                personInfo = this.$store.state.detail.personInfo;
            var otherCommentList = this.$store.state.othercomment.otherCommentList,
                otherL = otherCommentList.length,
                otherData = otherL > 0 ? otherCommentList[otherL-1] : undefined;
            if(!otherData) { return; }
            console.log('goToOtherComment-----', personInfo, otherData)
            this.$store.dispatch("comment/resetData");
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch("comment/initOtherPiPan", {
                detailData: personInfo,
                pipanData: otherData.pipan
            });
            // 他人批盘的分享数据设置
            this.$store.state.comment.otherShareTitle = otherData.title;
            this.$store.state.comment.otherShareCode = otherData.share;
            // 跳转页面
            setTimeout(() => {
                me.$router.replace('/comment/othercomment/' + personInfo.id);
                SHARE.initConfigShare();
            }, 100);
        },
        clickLunPan() {
            MIX.trackButtonClicked('mingpan_bottom_lunpan');
            this.$bus.emit('clearDetailNatureTime');
            // 初始化数据:批盘数据和他人批盘的列表数据一起拉下来
            var me = this;
            var personInfo = this.$store.state.detail.personInfo;
            this.$store.dispatch('discuss/resetData');
            this.$store.dispatch("discuss/initLunPanList", personInfo);
            // 页面跳转
            setTimeout(() => {
                me.$router.replace('/discusslist/' + personInfo.id);
                SHARE.initConfigShare();
            }, 10);
        },
        clickStartDiscuss() {
            this.$bus.emit('clearDetailNatureTime');
            this.$store.state.detail.showPipanLunpanPop = false;
            this.$router.push({
                path: '/discusscreate'
            });
        },
        clickReport() {
            MIX.trackButtonClicked('mingpan_bottom_ai');
            var me = this, detailInfo = this.personInfo,
                curPath = this.$router.history.current.path,
                curParams = this.$router.history.current.params;;
            this.$bus.emit('clearDetailNatureTime');
            this.$store.state.report.fromPage = 'detail';
            this.$store.dispatch('report/initReportAIConfig', {
                cb: function() {
                    me.$store.dispatch('report/getReportInfo', {
                        detailInfo: detailInfo,
                        cb: function() {
                            // 更新状态
                            var params = {"aitips": 1};
                            me.$store.dispatch('reminder/udpateExtList', {
                                params: params
                            });
                            // 处理分享页面
                            if(curPath.indexOf('share') != -1) {
                                me.$router.push({
                                    path: '/report/share/' + detailInfo.id
                                });
                                return;
                            }else {
                                if(curParams && curParams.from && curParams.from != '') {
                                    me.$router.replace('/report/'+curParams.from+'/'+curParams.id);
                                }
                            }
                        }
                    })
                }
            });
            
        },
        clickDS() {
            var detailInfo = this.personInfo;
            console.log('clickDS', detailInfo);
            if(!detailInfo.id) {
                this.$router.replace('/record');
                return;
            }
            if(this.showTips) {
                window.localStorage.setItem('h5_fate_ds_detail_tips', 1);
                this.showTips = false;
            }
            this.$showDeepSeek({
                id: detailInfo.id, type: 1,
                topClass: 'detail-main-panel',
            });
        },
        clickYearReport() {
            var detailInfo = this.personInfo,
                curPath = this.$router.history.current.path,
                curParams = this.$router.history.current.params;;
            console.log('clickYearReport-------', curParams, curPath);
            this.$store.dispatch('year/initYearCharacter', {
                detailInfo: detailInfo,
                characterCb: ()=> {
                    if(curParams && curParams.from && curParams.from != '') {
                        this.$router.replace('/yearcharacter/'+curParams.from+'/'+curParams.id);
                    }
                },
                reportCb: ()=> {
                    this.$store.dispatch('year/getYearReportInfo', {
                        cb: ()=> {
                            if(curParams && curParams.from && curParams.from != '') {
                                this.$router.replace('/year/'+curParams.from+'/'+curParams.id);
                            }
                        }
                    });
                }
            })
        }
    }
}
</script>